import React from 'react';
import { FaFolder } from 'react-icons/fa';
import { GoTriangleRight } from 'react-icons/go';
import classNames from 'classnames';

import { Icon } from '../icon';
import { useDropDownTreeContext } from './drop-down-tree.context';

export const DropDownTreeFolder: React.FC<{
  name: string;
  id: string;
  children?: React.ReactNode;
}> = ({ name, id, children }) => {
  const { selectedFolder, expandedFolders, onSelect, onToggle } =
    useDropDownTreeContext();

  const hasSubfolders = Boolean(children);
  const isSelected = id === selectedFolder;
  const isExpanded = expandedFolders.includes(id);

  const handleClick = () => {
    onSelect(id);

    if (hasSubfolders) {
      onToggle(id);
    }
  };

  return (
    <div>
      <div
        className={classNames(
          'inline-flex items-center select-none rounded px-2 py-1 space-x-2 cursor-pointer',
          isSelected ? 'bg-primary-150 text-primary-500' : 'text-gray-500',
          {
            'ml-6': !hasSubfolders,
          }
        )}
        onClick={handleClick}
      >
        {hasSubfolders && (
          <Icon
            size="16"
            icon={
              <GoTriangleRight
                className={classNames(
                  'flex-none transform transition-transform text-gray-300',
                  {
                    'rotate-90': isExpanded,
                  }
                )}
              />
            }
          />
        )}

        <Icon
          size="20"
          icon={
            <FaFolder
              className={classNames('flex-none text-xl', {
                'text-primary-200': !isSelected,
                'text-primary-500': isSelected,
              })}
            />
          }
        />

        <span className="flex-none text-sm">{name}</span>
      </div>
      <div className={classNames('pl-6', { hidden: !isExpanded })}>
        {children}
      </div>
    </div>
  );
};
